import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { removeLoan, removeBorrowersFromLoan } from '../../../common/api';
import { toast } from 'react-toastify';

import '../modals.css';

const DeleteLoan = ( { close, aid, uid, c, lid, name } ) => {
    const [ scope, setScope ] = useState( '' );
    
    const remove = async () => {
        let removed;
        let msg;

        switch ( scope ) {
            case 'borrower':
                removed = await removeBorrowersFromLoan( aid, uid, lid, [ c.details.cid ] );
                msg = `${c.details.firstname} has been removed as a borrower`;
                break;

            case 'loan':
                removed = await removeLoan( aid, uid, lid );
                msg = `${name} has been deleted`;
                break;

            default:
                console.log( 'Unknown scope - cannot delete anything' );
        }
        
        if ( removed.length ) {
            toast.success( msg, { theme: 'dark' } );
            close();
        }
    };

    return (
        <Fragment>
            <Modal.Header closeButton>
                <Modal.Title>Remove a Loan or Borrower</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='py-2'>
                    <Col>
                        <Form.Group>
                            <Form.Label>I want to:</Form.Label>
                            <Row>
                                <Col xs='auto'><Form.Check
                                    inline
                                    label="Remove the Entire Loan"
                                    name='scope'
                                    type='radio'
                                    id='loan'
                                    onChange={ ( e ) => setScope( 'loan' ) }
                                /></Col>
                                <Col xs='auto'><Form.Check
                                    inline
                                    label={`Only remove ${c.details.firstname} as a borrower`}
                                    name='scope'
                                    type='radio'
                                    id='borrower'
                                    onChange={ ( e ) => setScope( 'borrower' ) }
                                /></Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col>
                        <Button size='sm' variant='outline-primary' onClick={ () => remove() } disabled={ !['loan','borrower'].includes( scope ) }>Remove</Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    c: state.contacts.current
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( DeleteLoan );